"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("slick-carousel/slick/slick.css");

require("slick-carousel/slick/slick-theme.css");

var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));

var _react = _interopRequireDefault(require("react"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// Main component to render the slider
var CurrentOffersSlider = /*#__PURE__*/function (_React$Component) {
  _inherits(CurrentOffersSlider, _React$Component);

  var _super = _createSuper(CurrentOffersSlider);

  function CurrentOffersSlider(props) {
    _classCallCheck(this, CurrentOffersSlider);

    return _super.call(this, props);
  }

  _createClass(CurrentOffersSlider, [{
    key: "componentDidMount",
    value: function componentDidMount() {// this is for solving a bug in the businesspage where the slider is not visible at first
      // setTimeout(() => { this.slider.slickGoTo(0) }, 5000)
      // this.slider.slickGoTo(0)
      // this.slider.slickNext()
      // setTimeout(() => { this.slider.slickPrev() }, 100)
      // this.slider.slickPause()
      // this.slider.slickPlay()
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var props = this.props; // Setting up the arrow buttons

      var Arrow = function Arrow(props) {
        var className = props.className,
            onClick = props.onClick,
            dir = props.dir;
        return /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
          className: className,
          name: dir === "next" ? "ArrowRight" : "ArrowLeft",
          onClick: onClick
        });
      }; // The settings for the slider


      var settings = {
        // onInit: () => console.log(Slider),
        appendDots: function appendDots(dots) {
          return /*#__PURE__*/_react["default"].createElement("ul", null, dots.map(function (res, index) {
            return /*#__PURE__*/_react["default"].createElement("span", {
              key: index,
              onMouseOver: function onMouseOver() {
                return _this.slider.slickPause();
              },
              onMouseOut: function onMouseOut() {
                return _this.slider.slickPlay();
              }
            }, res, /*#__PURE__*/_react["default"].createElement("div", {
              className: "dot_title"
            }, props.creads[index].title));
          }));
        },
        arrows: true,
        autoplay: typeof props.lightbox === 'number' ? false : true,
        autoplaySpeed: 3000,
        centerMode: false,
        // centerMode: true,
        dots: true,
        infinite: true,
        initialSlide: 0,
        lazyload: true,
        nextArrow: /*#__PURE__*/_react["default"].createElement(Arrow, {
          dir: "next"
        }),
        prevArrow: /*#__PURE__*/_react["default"].createElement(Arrow, {
          dir: "prev"
        }),
        afterChange: function afterChange(e) {
          if (props.creads.length - 1 === e) {
            setTimeout(function () {
              _this.slider.slickGoTo(0);
            }, 3000);
          }
        },
        // responsive: [
        //     { breakpoint: 3840, settings: { slidesToShow: 10, slidesToScroll: 1 } },
        //     { breakpoint: 3450, settings: { slidesToShow: 8, slidesToScroll: 1 } },
        //     { breakpoint: 3050, settings: { slidesToShow: 7, slidesToScroll: 1 } },
        //     { breakpoint: 2450, settings: { slidesToShow: 6, slidesToScroll: 1 } },
        //     { breakpoint: 2150, settings: { slidesToShow: 5, slidesToScroll: 1 } },
        //     { breakpoint: 1750, settings: { slidesToShow: 4, slidesToScroll: 1 } },
        //     { breakpoint: 1450, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        //     { breakpoint: 1050, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        //     { breakpoint: 700, settings: { slidesToShow: 1, slidesToScroll: 1 } }
        // ],
        speed: 500,
        swipe: true,
        swipeToSlide: true,
        variableWidth: true,
        pauseOnhover: true
      };
      return /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], _extends({
        ref: function ref(slider) {
          return _this.slider = slider;
        }
      }, settings), props.creads.map(function (res, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: index,
          className: "co"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "coWrapper"
        }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
          className: "coView",
          name: "Search",
          onClick: function onClick() {
            return props.setLightbox(index);
          }
        }), /*#__PURE__*/_react["default"].createElement("img", {
          className: "coImage",
          alt: res.title,
          src: res.image
        })));
      }));
    }
  }]);

  return CurrentOffersSlider;
}(_react["default"].Component);

exports["default"] = CurrentOffersSlider;